// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TODO: Remove this once helptips are provided by confluence. */
.tc-aui-help-tip.aui-inline-dialog > .contents {
	-moz-box-sizing: border-box;
	-ms-box-sizing: border-box;
	box-sizing: border-box;
	padding: 16px;
	position: relative;
}

.tc-aui-help-tip.aui-inline-dialog .tc-helptip-title,
.tc-aui-help-tip.aui-inline-dialog .tc-helptip-body,
.tc-aui-help-tip.aui-inline-dialog .tc-helptip-link {
	margin-bottom: 0.5em;
}

.tc-aui-help-tip.aui-inline-dialog .tc-helptip-body {
	color: var(--ds-text, #292929);
}

.tc-aui-help-tip.aui-inline-dialog .tc-helptip-title {
	color: var(--ds-text, #292929);
	font-weight: normal;
	margin: 0;
}

.tc-aui-help-tip.aui-inline-dialog .tc-helptip-body h3 {
	margin-top: 0;
}
`, "",{"version":3,"sources":["webpack://./../confluence-editor/src/editor-plugins/team-calendar/helptip-component.css"],"names":[],"mappings":"AAAA,gEAAgE;AAChE;CACC,2BAA2B;CAC3B,0BAA0B;CAC1B,sBAAsB;CACtB,aAAa;CACb,kBAAkB;AACnB;;AAEA;;;CAGC,oBAAoB;AACrB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;CAC9B,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,aAAa;AACd","sourcesContent":["/* TODO: Remove this once helptips are provided by confluence. */\n.tc-aui-help-tip.aui-inline-dialog > .contents {\n\t-moz-box-sizing: border-box;\n\t-ms-box-sizing: border-box;\n\tbox-sizing: border-box;\n\tpadding: 16px;\n\tposition: relative;\n}\n\n.tc-aui-help-tip.aui-inline-dialog .tc-helptip-title,\n.tc-aui-help-tip.aui-inline-dialog .tc-helptip-body,\n.tc-aui-help-tip.aui-inline-dialog .tc-helptip-link {\n\tmargin-bottom: 0.5em;\n}\n\n.tc-aui-help-tip.aui-inline-dialog .tc-helptip-body {\n\tcolor: var(--ds-text, #292929);\n}\n\n.tc-aui-help-tip.aui-inline-dialog .tc-helptip-title {\n\tcolor: var(--ds-text, #292929);\n\tfont-weight: normal;\n\tmargin: 0;\n}\n\n.tc-aui-help-tip.aui-inline-dialog .tc-helptip-body h3 {\n\tmargin-top: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
